import * as Yup from 'yup'

export default Yup.object().shape({
  room_name: Yup.string()
              .required('legendErrorName')
              .min(4, 'legendErrorNameMin')
              .max(100, 'legendErrorNameMax')
})